import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { chatKitSessionBody, AI_ASSISTANT_API_BASE_URL } from '../constants';
export const useChatKitActions = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: clientSecretFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: escalateFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== clientSecretFetcher) {
    t2 = async () => clientSecretFetcher(`${AI_ASSISTANT_API_BASE_URL}/chatkit/session`, chatKitSessionBody);
    $[2] = clientSecretFetcher;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getClientSecret = t2;
  let t3;
  if ($[4] !== escalateFetcher) {
    t3 = async params => escalateFetcher(`${AI_ASSISTANT_API_BASE_URL}/support/escalate`, params);
    $[4] = escalateFetcher;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const escalateSupportRequest = t3;
  let t4;
  if ($[6] !== escalateSupportRequest || $[7] !== getClientSecret) {
    t4 = {
      getClientSecret,
      escalateSupportRequest
    };
    $[6] = escalateSupportRequest;
    $[7] = getClientSecret;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};